/**
 * Fade Out method
 *
 * @param {string} el
 */
export function fadeOut(el) {
    if (!el) {
        throw Error('"fadeOut function - "You didn\'t add required parameters');
    }

    const domElement =
        el instanceof HTMLElement ? el : document.querySelector(el);

    if (!domElement) {
        throw Error("domElement doesn't exist");
    }

    domElement.style.opacity = 1;

    (function fade() {
        if ((domElement.style.opacity -= 0.1) < 0) {
            domElement.style.display = 'none';
        } else {
            requestAnimationFrame(fade);
        }
    })();
}

/**
 * Fade In method
 *
 * @param {string} el      - element that need to fade in
 *
 * @param {string} display - display variant
 */
export function fadeIn(el, display = 'block') {
    if (el === undefined) return;
    if (!el) {
        throw Error('"fadeIn function - "You didn\'t add required parameters');
    }

    const domElement = document.querySelector(el);

    if (!domElement) {
        throw Error("domElement doesn't exist");
    }

    domElement.style.opacity = 0;
    domElement.style.display = display || 'block';

    (function fade() {
        let val = parseFloat(domElement.style.opacity);
        if (!((val += 0.1) > 1)) {
            domElement.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
}

/**
 * Sets the `href` attribute of a link with the specified class.
 *
 * @param {string} href - The URL to set as the `href` attribute.
 * @param {string} selector - The CSS selector to identify the link (default: `.js-accessible-docs-link`).
 */
export const setLinkHref = (href, selector = '.js-accessible-docs-link') => {
    const link = document.querySelector(selector);

    if (link) {
        link.href = href;
    } else {
        console.warn(`No link found with the selector: ${selector}`);
    }
};

/**
 * Clears popup.
 */
export const clearPopup = () => {
    const link = document.querySelector('.js-accessible-docs-link');
    const popup = document.querySelector('.js-accessible-docs-popup');
    const loader = document.querySelector('.js-accessible-docs-popup-loader');

    if (link) {
        link.href = '#';
    }

    if (popup) {
        popup.classList.remove('error', 'in-process', 'completed');
    }

    if (loader) {
        loader.classList.remove('active');
    }
};
